import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {labels} from '../../../../../../../util/utils';
import Utility from '../../../../../../../util/utilityfunctions';
import {actionIcInfoOutline24px} from '@ey/motif-react-wrapper/assets/icons/index';
import StyledBodySpecialAccordionContentListItem from '../StyledBodySpecialAccordionContentListItem';
import StyledBodySpecialGridSecondaryColumn from '../StyledBodySpecialGridSecondaryColumn';
import Icon from '../../../../../BaseComponentWrappers/MotifIcon';

function ControlsUnrelatedRow({applicationControlIds, itdmControlIds}) {
	let applicationCounter = Utility.showISA315Counter(applicationControlIds.length);
	let itdmCounter = Utility.showISA315Counter(itdmControlIds.length);

	return (
		<StyledAccordionContentListItemRow className="StyledAccordionContentListItemRow">
			<StyledItApplicationColumn className="StyledItApplicationColumn">
				<Icon src={actionIcInfoOutline24px} />
				<span>{labels.controlsWithoutRelatedItApps}</span>
			</StyledItApplicationColumn>
			<StyledCountColumnRelatedITApps className={`StyledCountColumnRelatedITApps StyledCountColumn`}>
				<StyledBodySpecialGridSecondaryColumn />
			</StyledCountColumnRelatedITApps>
			<StyledCountColumnApplication
				className={`StyledCountColumnApplication StyledCountColumn1 ${
					applicationControlIds.length > 0 ? 'StyledCountValue' : ''
				}`}
			>
				<StyledBodySpecialGridSecondaryColumn>{applicationCounter}</StyledBodySpecialGridSecondaryColumn>
			</StyledCountColumnApplication>
			<StyledCountColumnITDM
				className={`StyledCountColumnITDM StyledCountColumn2 ${itdmControlIds.length > 0 ? 'StyledCountValue' : ''}`}
			>
				<StyledBodySpecialGridSecondaryColumn>{itdmCounter}</StyledBodySpecialGridSecondaryColumn>
			</StyledCountColumnITDM>
		</StyledAccordionContentListItemRow>
	);
}

ControlsUnrelatedRow.propTypes = {
	applicationControlIds: PropTypes.number,
	itdmControlIds: PropTypes.number
};

export default ControlsUnrelatedRow;

const StyledAccordionContentListItemRow = styled(StyledBodySpecialAccordionContentListItem)`
	border-bottom: unset;
	font-weight: unset;
`;

const StyledItApplicationColumn = styled.section`
	display: flex;
	align-items: center;
	font-size: var(--px-14);
	font-weight: 300;
	color: var(--red-600) !important;
	width: calc(100% - var(--px-380));
	.motif-icon {
		display: inline-flex;
		height: var(--px-16);
		width: var(--px-16);
		padding-left: 0;
		svg {
			fill: var(--red-600) !important;
		}
	}
	span {
		padding-left: var(--px-5);
		color: var(--red-600) !important;
	}
`;

const StyledCountColumnRelatedITApps = styled.section`
	width: var(--px-120);
	padding: 0 var(--px-10) 0 0 !important;
	margin-left: var(--px-20);
	font-weight: normal;
	font-size: var(--px-14);
	&.StyledCountValue {
		color: var(--red-600) !important;
		* {
			color: var(--red-600) !important;
		}
	}
`;

const StyledCountColumnApplication = styled.section`
	width: var(--px-120);
	padding: 0 var(--px-10) 0 0 !important;
	font-weight: normal;
	font-size: var(--px-14);
	&.StyledCountValue {
		color: var(--red-600) !important;
		* {
			color: var(--red-600) !important;
		}
	}
`;

const StyledCountColumnITDM = styled.section`
	width: var(--px-90);
	padding: 0 0 0 var(--px-10) !important;
	font-weight: normal;
	font-size: var(--px-14);
	&.StyledCountValue {
		color: var(--red-600) !important;
		* {
			color: var(--red-600) !important;
		}
	}
`;
